import { APP_DOMAIN_COMISSAO } from '../config/urls';

// Mesmas assinaturas, campos e rotas usados por Mail/EmailServices.
const URL_LOGIN = `${APP_DOMAIN_COMISSAO}/login`;
// PNG oficial, sem redesenho: letras pretas e detalhes vermelhos.
const URL_LOGO = 'https://alpha-connect-email-identidade.vercel.app/logo-alpha-convites-preto-vermelho-20260929.png';
const FONTE = 'Arial, Helvetica, sans-serif';

export function escaparHtml(valor) {
  return String(valor === undefined || valor === null ? '' : valor)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

// Capelo de formatura com quadrados cinza (PNG 3x, exibido em 136 × 136).
// Fonte editável: images/capelo-formatura.svg.
const URL_CAPELO = 'https://alpha-connect-email-identidade.vercel.app/capelo-formatura-20260930.png';

function credencial(rotulo, valor, senha = false) {
  return `<tr>
                  <td class="rotulo" width="68" valign="top" style="width:68px; padding:17px 10px 17px 0; border-bottom:1px solid #E5E5E5; font-family:${FONTE}; font-size:12px; line-height:25px; color:#707070;">${rotulo}</td>
                  <td class="dado" valign="top" style="padding:17px 0; border-bottom:1px solid #E5E5E5; font-family:${senha ? "Consolas, 'Courier New', monospace" : FONTE}; font-size:17px; line-height:25px; font-weight:${senha ? '600' : '500'}; color:#111111; word-break:break-all; overflow-wrap:anywhere;">${valor}</td>
                </tr>`;
}

function layoutAcesso({ area, texto, login, senha, urlAcesso, rodape }) {
  return `<!DOCTYPE html>
<html lang="pt-BR" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="x-apple-disable-message-reformatting">
  <meta name="format-detection" content="telephone=no, date=no, address=no, email=no">
  <meta name="color-scheme" content="light">
  <meta name="supported-color-schemes" content="light">
  <title>Seu acesso está pronto. | Alpha Connect</title>
  <!--[if mso]>
  <noscript><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml></noscript>
  <![endif]-->
  <style>
    body { margin:0 !important; padding:0 !important; width:100% !important; -webkit-text-size-adjust:100%; -ms-text-size-adjust:100%; }
    table, td { mso-table-lspace:0pt; mso-table-rspace:0pt; }
    img { border:0; outline:none; text-decoration:none; -ms-interpolation-mode:bicubic; }
    a[x-apple-data-detectors], .dado a, u + #body .dado a { color:#111111 !important; text-decoration:none !important; font-size:inherit !important; font-family:inherit !important; line-height:inherit !important; }
    .botao:focus { outline:2px solid #666666; outline-offset:4px; }
    @media screen and (max-width:620px) {
      .externo { padding:0 !important; }
      .container { width:100% !important; }
      .marca { padding-left:24px !important; padding-top:20px !important; }
      .logo { width:140px !important; height:70px !important; }
      .canto { width:104px !important; }
      .mosaico { width:104px !important; height:104px !important; }
      .conteudo { padding:22px 24px 0 !important; }
      .titulo { font-size:26px !important; line-height:34px !important; }
      .rotulo { width:52px !important; padding-right:8px !important; }
      .dado { font-size:16px !important; line-height:25px !important; }
      .acao { width:100% !important; }
      .rodape { padding-left:24px !important; padding-right:24px !important; padding-bottom:48px !important; }
    }
  </style>
</head>
<body id="body" style="margin:0; padding:0; background-color:#F5F5F5;">
  <div style="display:none; font-size:1px; line-height:1px; max-height:0; max-width:0; opacity:0; overflow:hidden; mso-hide:all;">Seu acesso à Alpha Connect está pronto. Confira seus dados para entrar.&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;&#847;&zwnj;&nbsp;</div>
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" bgcolor="#F5F5F5" style="width:100%; background-color:#F5F5F5;">
    <tr><td align="center" class="externo" style="padding:32px 16px;">
      <!--[if mso]><table role="presentation" width="600" cellspacing="0" cellpadding="0" border="0" align="center"><tr><td><![endif]-->
      <table class="container" role="presentation" width="600" cellspacing="0" cellpadding="0" border="0" bgcolor="#FFFFFF" style="width:100%; max-width:600px; table-layout:fixed; background-color:#FFFFFF;">
        <tr><td>
          <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width:100%; table-layout:fixed;">
            <tr>
              <td class="marca" valign="top" style="padding:28px 0 0 48px;">
                <img class="logo" src="${URL_LOGO}" width="160" height="80" alt="Alpha Convites" style="display:block; width:160px; height:80px; border:0; font-family:${FONTE}; font-size:17px; line-height:22px; font-weight:bold; color:#111111;">
                <p style="margin:0; font-family:${FONTE}; font-size:12px; line-height:18px; color:#777777;">Alpha Connect</p>
              </td>
              <td class="canto" width="136" valign="top" align="right" style="width:136px; padding:0;"><img class="mosaico mosaico-superior" src="${URL_CAPELO}" width="136" height="136" alt="" aria-hidden="true" style="display:block; width:136px; height:136px; border:0;"></td>
            </tr>
          </table>
        </td></tr>
        <tr><td class="conteudo" style="padding:28px 48px 0;">
          <p class="area" style="margin:0 0 10px; font-family:${FONTE}; font-size:12px; line-height:18px; color:#707070;">${area}</p>
          <h1 class="titulo" style="margin:0; font-family:${FONTE}; font-size:28px; line-height:36px; letter-spacing:-0.5px; font-weight:600; color:#111111;">Seu acesso está pronto.</h1>
          <p style="margin:14px 0 26px; font-family:${FONTE}; font-size:15px; line-height:24px; color:#666666;">${texto}</p>
          <table class="credenciais" role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width:100%; table-layout:fixed; border-top:1px solid #E5E5E5;">
            ${credencial('Login', login)}${credencial('Senha', senha, true)}
          </table>
          <p style="margin:12px 0 28px; font-family:${FONTE}; font-size:12px; line-height:19px; color:#777777;">Seu acesso é pessoal. Não compartilhe sua senha.</p>
          <table class="acao" role="presentation" width="268" cellspacing="0" cellpadding="0" border="0" style="width:268px; max-width:100%;">
            <tr><td align="center" bgcolor="#444444" style="background-color:#444444; border-radius:6px;">
              <!--[if mso]>
              <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${urlAcesso}" style="height:50px; v-text-anchor:middle; width:268px;" arcsize="12%" stroke="f" fillcolor="#444444"><w:anchorlock/><center style="color:#FFFFFF; font-family:Arial,sans-serif; font-size:15px; font-weight:bold;">Acessar Alpha Connect</center></v:roundrect>
              <![endif]-->
              <!--[if !mso]><!-->
              <a class="botao" href="${urlAcesso}" target="_blank" style="display:block; padding:15px 12px; border-radius:6px; background-color:#444444; color:#FFFFFF; font-family:${FONTE}; font-size:15px; line-height:20px; font-weight:bold; text-align:center; text-decoration:none;">Acessar Alpha Connect</a>
              <!--<![endif]-->
            </td></tr>
          </table>
          <p style="margin:22px 0 0; font-family:${FONTE}; font-size:12px; line-height:19px; color:#777777;">Ou copie este endereço no navegador:</p>
          <p style="margin:4px 0 0; font-family:${FONTE}; font-size:12px; line-height:19px;"><a href="${urlAcesso}" target="_blank" style="font-family:${FONTE}; color:#555555; text-decoration:underline; word-break:break-all; overflow-wrap:anywhere;">${urlAcesso}</a></p>
        </td></tr>
        <tr><td class="rodape" style="padding:28px 48px 128px;">
          <p style="margin:0; padding-top:20px; border-top:1px solid #EAEAEA; font-family:${FONTE}; font-size:11px; line-height:18px; color:#777777;">${rodape}</p>
          <p style="margin:10px 0 0; font-family:${FONTE}; font-size:11px; line-height:18px; color:#777777;">Alpha Convites - Acesso à Alpha Connect</p>
        </td></tr>
      </table>
      <!--[if mso]></td></tr></table><![endif]-->
    </td></tr>
  </table>
</body>
</html>`;
}

export function templateAcessoComissao(data) {
  return layoutAcesso({
    area:'Área da Comissão',
    texto:'Use os dados abaixo para acompanhar sua turma, os pedidos e as aprovações na Alpha Connect.',
    login:escaparHtml(data.login.email),
    senha:escaparHtml(data.login.senha),
    urlAcesso:`${URL_LOGIN}?tipo=comissao`,
    rodape:'No primeiro acesso, consulte o tutorial disponível na Área da Comissão.',
  });
}

export function templateAcessoFormando(usuario) {
  const saudacao=usuario.nome ? `Olá, ${escaparHtml(usuario.nome)}. ` : '';
  return layoutAcesso({
    area:'Área do Formando',
    texto:`${saudacao}Use os dados abaixo para acompanhar seu convite e seus pedidos na Alpha Connect.`,
    login:escaparHtml(usuario.email),
    senha:escaparHtml(usuario.senha),
    urlAcesso:`${URL_LOGIN}?tipo=formando`,
    rodape:'Em caso de dúvida, fale com a sua comissão de formatura.',
  });
}



// WEBPACK FOOTER //
// ./src/services/templatesAcesso.js